// Backend product value -> label shown in the UI. The backend value is what must
// be sent in the `product` query param (exact string, otherwise the list comes
// back empty). Unmapped products are shown as-is.
const PRODUCT_LABELS = {
    govgistic: 'Government Data',
}

export const getProductLabel = (product) =>
    PRODUCT_LABELS[String(product || '').toLowerCase()] || product
